var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceDesktopShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,1.2c0-.1,0-.2,0-.3,0,0,0,0,0-.1,0-.1-.1-.2-.2-.3-.1-.1-.2-.2-.3-.2,0,0,0,0-.1,0-.1,0-.2,0-.3,0,0,0,0,0,0,0-.1,0-.2,0-.4,0L1.2,7.9c-.4.2-.7.5-.9.9-.2.4-.2.9,0,1.4.2.5.5.8.9,1l7.9,3.9,3.9,7.8c.2.4.5.7.9.9.2.1.5.2.8.2s.4,0,.6-.1c.5-.2.8-.5,1.1-1L23.9,1.7c0-.1,0-.2,0-.4,0,0,0,0,0,0ZM18.3,4.2l-8.6,8.6-6.4-3.2,15-5.4ZM14.5,20.8l-3.2-6.4,8.6-8.6-5.4,15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceDesktopShare);
export default __webpack_public_path__ + "static/media/device-desktop-share.c3d7641e01d61d7e1316d92166f5d18f.svg";
export { ForwardRef as ReactComponent };